/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_ProcessingInputs */

const en_audio_description_export_loudness_processing = /** @type {(inputs: Audio_Description_Export_Loudness_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing loudness analysis data...`)
};

const fr_audio_description_export_loudness_processing = /** @type {(inputs: Audio_Description_Export_Loudness_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement des données d'analyse de loudness...`)
};

const de_audio_description_export_loudness_processing = /** @type {(inputs: Audio_Description_Export_Loudness_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitung von Lautheitsanalysedaten...`)
};

const it_audio_description_export_loudness_processing = /** @type {(inputs: Audio_Description_Export_Loudness_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione dei dati di analisi della rumorosità...`)
};

const ru_audio_description_export_loudness_processing = /** @type {(inputs: Audio_Description_Export_Loudness_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка данных анализа громкости...`)
};

const es_audio_description_export_loudness_processing = /** @type {(inputs: Audio_Description_Export_Loudness_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando datos de análisis de sonoridad...`)
};

const zh_cn2_audio_description_export_loudness_processing = /** @type {(inputs: Audio_Description_Export_Loudness_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在处理响度分析数据……`)
};

const ja_audio_description_export_loudness_processing = /** @type {(inputs: Audio_Description_Export_Loudness_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラウドネス分析データを処理しています...`)
};

const hi_audio_description_export_loudness_processing = /** @type {(inputs: Audio_Description_Export_Loudness_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ध्वनि विश्लेषण डेटा संसाधित किया जा रहा है...`)
};

const pt_pt2_audio_description_export_loudness_processing = /** @type {(inputs: Audio_Description_Export_Loudness_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processamento de dados de análise de intensidade sonora...`)
};

/**
* | output |
* | --- |
* | "Processing loudness analysis data..." |
*
* @param {Audio_Description_Export_Loudness_ProcessingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_processing = /** @type {((inputs?: Audio_Description_Export_Loudness_ProcessingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_ProcessingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_loudness_processing(inputs)
	if (locale === "de") return de_audio_description_export_loudness_processing(inputs)
	if (locale === "it") return it_audio_description_export_loudness_processing(inputs)
	if (locale === "ru") return ru_audio_description_export_loudness_processing(inputs)
	if (locale === "es") return es_audio_description_export_loudness_processing(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_loudness_processing(inputs)
	if (locale === "ja") return ja_audio_description_export_loudness_processing(inputs)
	if (locale === "hi") return hi_audio_description_export_loudness_processing(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_loudness_processing(inputs)
	return en_audio_description_export_loudness_processing(inputs)
});